import { connect } from 'react-redux';

import { IState } from '../../store/index';
import { ISeoLinksProps, SeoLinks } from './index';

export function mapStateToProps(state: IState): ISeoLinksProps {
  return {
    seoLinks: state.seoLinks.seoLinks,
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SeoLinksContainer = connect<ISeoLinksProps>(mapStateToProps)(SeoLinks);
